const dealerID = 4
const dealerGroupID = 3
const manufacturerRegionID = 2
const manufacturerID = 1
//const rootID = 0
export const orgTypes = {
    dealerID,
    dealerGroupID,
    manufacturerRegionID,
    manufacturerID
}




// WEBPACK FOOTER //
// ./src/constants/orgTypes.js